import { Button } from "@shared/components/untitledui/base/buttons/button"
import type { ReactNode } from "react"
import { ViewShell } from "./ViewShell"

/**
 * A drilled-in confirmation: optional body text, Cancel, and one confirm button (the
 * question itself is the view's title, shown in the menu's header bar). Covers the Figma
 * "Delete the lesson?", "You have a lesson here…", and "Important Note" surfaces — vary
 * the copy and tone.
 */
export function ConfirmView({
  body,
  confirmLabel,
  destructive,
  onCancel,
  onConfirm,
}: {
  body?: ReactNode
  confirmLabel: string
  /** Red confirm button for destructive actions. */
  destructive?: boolean
  onCancel: () => void
  /** Omit while the action isn't wired up yet: the confirm button renders disabled. */
  onConfirm?: () => void
}) {
  return (
    <ViewShell
      actions={
        <>
          <Button color="secondary" size="md" className="flex-1" onPress={onCancel}>
            Cancel
          </Button>
          <Button
            data-test="view confirm"
            color={destructive ? "primary-destructive" : "primary"}
            size="md"
            className="flex-1"
            isDisabled={!onConfirm}
            onPress={onConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {body ? <p className="m-0 px-5 pt-4 text-base text-gray-700">{body}</p> : null}
    </ViewShell>
  )
}
